<template>
  <!-- Select Modal -->
  <div class="modal-optim">
    <div class="inside-modal-optim">
      <ButtonClose fontSize="15" @btnAbort="onUserCancelStrat" />
      <div class="row f-row justify-content-center">
        <div class="col col-5 markets-chart-title bdr-b-h">
          Long hedges
        </div>
        <div class="col col-1 markets-chart-title"></div>
        <div class="col col-5 markets-chart-title bdr-b-h">
          Short hedges
        </div>
      </div>
      <div class="row f-row justify-content-center">
        <div class="col col-5">
          <table class="table table-sm table-borderless optim-strat-table">
            <tbody>
              <tr
                v-for="(item, index) in strategiesOrdered.long"
                :key="index"
                class="tr"
              >
                <th style="width: 5%">{{ index + 1 }}</th>
                <td style="width: 95%">
                  <button
                    type="button"
                    class="btn btn-optim-strat"
                    v-on:click="onUserIncludeStrat(item)"
                  >
                    {{ item.name }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col col-1"></div>
        <div class="col col-5">
          <table class="table table-sm table-borderless optim-strat-table">
            <tbody>
              <tr
                v-for="(item, index) in strategiesOrdered.short"
                :key="index"
                class="tr"
              >
                <th style="width: 5%">{{ index + 1 }}</th>
                <td style="width: 95%">
                  <button
                    type="button"
                    class="btn btn-optim-strat"
                    v-on:click="onUserIncludeStrat(item)"
                  >
                    {{ item.name }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row f-row justify-content-center mt-3">
        <div class="col col-11 markets-chart-title bdr-b-h">
          Volatility strategies
        </div>
      </div>
      <div class="row f-row justify-content-center">
        <div class="col col-5">
          <table class="table table-sm table-borderless optim-strat-table">
            <tbody>
              <tr
                v-for="(item, index) in strategiesOrdered.vol"
                :key="index"
                class="tr"
                v-show="index / 2 === Math.round(index / 2)"
              >
                <th style="width: 5%">{{ index + 1 }}</th>
                <td style="width: 95%">
                  <button
                    type="button"
                    class="btn btn-optim-strat"
                    v-on:click="onUserIncludeStrat(item)"
                  >
                    {{ item.name }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col col-1"></div>
        <div class="col col-5 mb-3">
          <table class="table table-sm table-borderless optim-strat-table">
            <tbody>
              <tr
                v-for="(item, index) in strategiesOrdered.vol"
                :key="index"
                class="tr"
                v-show="(index + 1) / 2 === Math.round((index + 1) / 2)"
              >
                <th style="width: 5%">{{ index + 1 }}</th>
                <td style="width: 95%">
                  <button
                    type="button"
                    class="btn btn-optim-strat"
                    v-on:click="onUserIncludeStrat(item)"
                  >
                    {{ item.name }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonClose from "@/components/buttons/Close";
export default {
  name: "SelectStrategiesModal",
  components: {
    ButtonClose
  },
  props: {
    strategiesOrdered: { required: true }
  },
  data() {
    return {};
  },
  methods: {
    onUserIncludeStrat(item) {
      this.$emit("eventOnUserIncludeStrat", item);
    },
    onUserCancelStrat() {
      this.$emit("eventOnUserCancelStrat");
    }
  }
};
</script>

<style scoped>
.container__button {
  max-width: 20px;
  max-height: 20px;
}
</style>
